import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { TextArea } from '../../../../components/workbook/forms';

export default function Worksheet1_1Page() {
  const [badQuestions, setBadQuestions] = useState<string[]>(['', '', '']);

  const updateQuestion = (index: number, value: string) => {
    const updated = [...badQuestions];
    updated[index] = value;
    setBadQuestions(updated);
  };

  return (
    <div className="min-h-screen bg-[var(--bg-raised)]">
      <header className="bg-[var(--slate-dim)] border-b border-[var(--slate)]">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <Link
            to="/elevation/workbook/oqf/module-1"
            className="text-[var(--text-sec)] hover:text-[var(--text-pri)] text-sm mb-2 inline-flex items-center gap-1"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Module 1
          </Link>
          <h1 className="text-2xl font-bold text-[var(--text-pri)]">
            ✍️ Activity: Worksheet 1.1
          </h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-[var(--surface)] p-6 mb-6">
          <h2 className="text-lg font-semibold text-[var(--text-pri)] mb-3">
            Instructions
          </h2>
          <p className="text-[var(--text-sec)]">
            Read the scenario below. In the space provided, write down 2-3 of the vague, bundled, or biased questions you see hiding in the text.
          </p>
        </div>

        <div className="bg-[var(--slate-dim)] border-l-4 border-[var(--slate)] p-6 mb-6">
          <h2 className="text-lg font-semibold text-[var(--text-pri)] mb-4">
            Scenario A: "The Pro Tier Push"
          </h2>
          <div className="text-[var(--text-sec)] space-y-3">
            <p>
              The executive team wants to launch a new "Pro" tier for the company's software next quarter. They're convinced it will drive revenue growth, but a recent customer survey showed frustration with existing features and unclear value.
            </p>
            <p>
              Marketing argues the best move is to double down on social media campaigns to "get the word out." Engineering isn't sure they can deliver the promised premium features without delaying other commitments. Product hasn't clarified which customers the tier is actually for—or what "Pro" is supposed to mean. Meanwhile, Finance is asking for projected upgrade rates to justify the investment.
            </p>
          </div>
        </div>

        <div className="bg-[var(--bg-raised)] border border-[var(--rule)] p-6 mb-6">
          <h2 className="text-lg font-semibold text-[var(--text-pri)] mb-4">
            What "bad" questions or core uncertainties do you see?
          </h2>
          <div className="space-y-4">
            {badQuestions.map((question, index) => (
              <div key={index}>
                <TextArea
                  label={`Question ${index + 1}`}
                  value={question}
                  onChange={(e) => updateQuestion(index, e.target.value)}
                  placeholder="Enter a vague, bundled, or biased question you identified..."
                  rows={3}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[var(--mustard-dim)] border border-[var(--mustard)] p-4 mb-6">
          <h3 className="font-semibold text-[var(--mustard)] mb-2">💡 Tip</h3>
          <p className="text-sm text-[var(--mustard)]">
            Look for questions that are:
          </p>
          <ul className="list-disc list-inside text-sm text-[var(--mustard)] mt-2 space-y-1">
            <li>Vague (using words like "like", "should", "good")</li>
            <li>Bundled (asking multiple things at once)</li>
            <li>Biased (implying a solution or argument)</li>
          </ul>
        </div>

        <div className="flex justify-between items-center">
          <Link
            to="/elevation/workbook/oqf/module-1"
            className="px-4 py-2 border border-[var(--rule)] text-[var(--text-sec)] hover:bg-[var(--surface)] inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Link>
          <Link
            to="/elevation/workbook/oqf/module-1/worksheet-1-2"
            className="px-4 py-2 bg-[var(--slate)] text-white hover:bg-[var(--slate)] inline-flex items-center gap-2"
          >
            Next: Worksheet 1.2
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}






